import React from 'react';
import { useNavigate } from 'react-router-dom';
import snipeLogo from '../../assets/snipe_logo.png';

function ResponsibleGambling() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-[#020817] text-white">
            {/* Gradient Background */}
            <div className="fixed inset-0 z-0 bg-[#020817]">
                <div className="absolute top-0 left-1/4 w-96 h-96 bg-emerald-500/10 rounded-full blur-3xl"></div>
                <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl"></div>
            </div>

            {/* Content */}
            <div className="relative z-10">
                {/* Header */}
                <nav className="container mx-auto px-4 sm:px-6 py-4 flex items-center justify-between border-b border-slate-800/50">
                    <button onClick={() => navigate('/')} className="cursor-pointer">
                        <img src={snipeLogo} alt="Snipe Logo" className="h-16 sm:h-20 w-auto object-contain" />
                    </button>
                    <button 
                        onClick={() => navigate('/')}
                        className="bg-gradient-to-r from-emerald-600 to-teal-600 px-6 sm:px-8 py-2 sm:py-3 rounded-lg font-semibold text-white hover:from-emerald-700 hover:to-teal-700 transition duration-200 shadow-lg shadow-emerald-500/20 hover:shadow-emerald-500/30"
                    >
                        Back to Home
                    </button>
                </nav>

                {/* Responsible Gambling Content */}
                <div className="container mx-auto px-4 sm:px-6 py-12 max-w-4xl text-left">
                    <div className="bg-gradient-to-br from-[#0f172a] to-[#020617] rounded-2xl border border-slate-800/50 p-6 sm:p-10 text-left">
                        <h1 className="text-2xl sm:text-3xl font-bold mb-6 text-white text-left">
                            Responsible Gambling
                        </h1>

                        {/* Header Info */}
                        <div className="bg-slate-800/30 rounded-lg p-4 border border-slate-700/50 mb-6 text-left">
                            <p className="text-xs sm:text-sm mb-1.5 text-slate-400 text-left"><strong className="text-slate-300">Last updated:</strong> 16/01/2026</p>
                            <p className="text-xs sm:text-sm text-slate-400 text-left"><strong className="text-slate-300">Support:</strong> <a href="mailto:info@snipeaio.com" className="text-emerald-400 hover:text-emerald-300 underline">info@snipeaio.com</a></p>
                        </div>

                        <div className="space-y-6 text-slate-300 text-left">
                            {/* Section 1 */}
                            <section className="text-left">
                                <h2 className="text-base sm:text-lg font-semibold mb-3 text-white text-left">18+ only</h2>
                                <p className="text-sm leading-relaxed text-left">
                                    Our Service is for adults only. Gambling involves risk and can cause harm.
                                </p>
                            </section>

                            {/* Section 2 */}
                            <section className="text-left">
                                <h2 className="text-base sm:text-lg font-semibold mb-3 text-white text-left">Keep it under control</h2>
                                <ul className="list-disc list-inside space-y-1.5 text-sm leading-relaxed ml-4 text-left">
                                    <li>set a budget before you bet</li>
                                    <li>set a time limit</li>
                                    <li>don't chase losses</li>
                                    <li>take breaks</li>
                                    <li>avoid betting when stressed, angry, or under the influence</li>
                                    <li>if it stops being fun, stop</li>
                                </ul>
                            </section>

                            {/* Section 3 */}
                            <section className="text-left">
                                <h2 className="text-base sm:text-lg font-semibold mb-3 text-white text-left">Self-exclusion (Australia)</h2>
                                <p className="text-sm leading-relaxed text-left">
                                    You can self-exclude from licensed Australian online and phone wagering providers using <a href="https://www.betstop.gov.au" target="_blank" rel="noopener noreferrer" className="text-emerald-400 hover:text-emerald-300 underline">BetStop</a>.
                                </p>
                            </section>

                            {/* Section 4 */}
                            <section className="text-left">
                                <h2 className="text-base sm:text-lg font-semibold mb-3 text-white text-left">Free support (Australia)</h2>
                                <p className="text-sm leading-relaxed mb-2 text-left">
                                    <a href="https://www.gamblinghelponline.org.au" target="_blank" rel="noopener noreferrer" className="text-emerald-400 hover:text-emerald-300 underline">Gambling Help Online</a> offers free support and counselling (24/7).
                                </p>
                                <p className="text-sm leading-relaxed text-left">
                                    If you're in immediate danger or crisis, call emergency services or <a href="tel:131114" className="text-emerald-400 hover:text-emerald-300 underline">Lifeline (13 11 14)</a>.
                                </p>
                            </section>
                        </div>
                    </div>

                    {/* Back to Home Button at bottom */}
                    <div className="text-center mt-8 sm:mt-12">
                        <button
                            onClick={() => navigate('/')}
                            className="bg-gradient-to-r from-emerald-600 to-teal-600 px-8 py-3 rounded-lg font-semibold text-white hover:from-emerald-700 hover:to-teal-700 transition duration-200 shadow-lg shadow-emerald-500/20 hover:shadow-emerald-500/30"
                        >
                            Back to Home
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResponsibleGambling;

